/**
 * @generated SignedSource<<1a2b634a842f25bfd8dcffec232ec85c>>
 * @relayHash 5739cedf14c2d79a92d1595bb5ab39bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 74baecdead55bb37e9dafab316c22eb29bcd811fe3ea782224b5bc34d942374f

import type { ConcreteRequest } from 'relay-runtime';
export type useBlueprintTypeEditorEditorLabelsQuery$variables = {
  contentId: string;
};
export type useBlueprintTypeEditorEditorLabelsQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly labels: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly name: string | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};
export type useBlueprintTypeEditorEditorLabelsQuery = {
  response: useBlueprintTypeEditorEditorLabelsQuery$data;
  variables: useBlueprintTypeEditorEditorLabelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "concreteType": "PaginatedLabelList",
            "kind": "LinkedField",
            "name": "labels",
            "plural": false,
            "selections": [
              {
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useBlueprintTypeEditorEditorLabelsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBlueprintTypeEditorEditorLabelsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "5739cedf14c2d79a92d1595bb5ab39bc",
    "id": "74baecdead55bb37e9dafab316c22eb29bcd811fe3ea782224b5bc34d942374f",
    "metadata": {},
    "name": "useBlueprintTypeEditorEditorLabelsQuery",
    "operationKind": "query",
    "text": "query useBlueprintTypeEditorEditorLabelsQuery($contentId:ID!){content(id:$contentId){nodes{id,labels{nodes{id,name}}}}}"
  }
};
})();

(node as any).hash = "8e81347d292c21680357fc15576d537d";

export default node;
